export var buildInGameOnboardingStyles = function (prefix, zBase) {
    var _a;
    return (_a = {},
        _a["".concat(prefix, "Overlay")] = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            overflow: 'visible',
            zIndex: zBase,
        },
        _a["".concat(prefix, "Dimmer")] = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: zBase - 1,
        },
        _a["".concat(prefix, "CutoutRing")] = {
            position: 'absolute',
            border: '2px solid rgba(252, 165, 4, 0.7)',
            boxShadow: '0 0 12px rgba(255, 255, 255, 0.45)',
            pointerEvents: 'none',
            zIndex: zBase + 3,
        },
        _a["".concat(prefix, "Arrow")] = {
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            color: '#fdba00',
            fontSize: 12,
            fontWeight: 600,
            pointerEvents: 'none',
            transformOrigin: 'right center',
            zIndex: zBase + 3,
        },
        _a["".concat(prefix, "ArrowGraphic")] = {
            width: 140,
            height: 60,
            overflow: 'visible',
        },
        _a["".concat(prefix, "ArrowHead")] = {
            fill: 'none',
            stroke: '#dd752f',
            strokeWidth: 4,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
        },
        _a["".concat(prefix, "ArrowPath")] = {
            fill: 'none',
            stroke: '#dd752f',
            strokeWidth: 4,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: '3 6',
        },
        _a["".concat(prefix, "Label")] = {
            position: 'absolute',
            width: 'min(24vw, 220px)',
            maxWidth: 'min(24vw, calc(100vw - 32px))',
            background: '#fdba00',
            color: '#000',
            borderRadius: 10,
            padding: '8px 10px',
            fontSize: 12,
            lineHeight: 1.4,
            wordBreak: 'break-word',
            boxShadow: '0 10px 24px rgba(0, 0, 0, 0.35)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            pointerEvents: 'none',
            zIndex: zBase + 3,
        },
        _a["".concat(prefix, "Card")] = {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            maxWidth: 360,
            background: '#1c1d23',
            borderRadius: 12,
            padding: '16px 18px',
            color: '#000000',
            boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)',
            textAlign: 'left',
            zIndex: zBase + 5,
        },
        _a["".concat(prefix, "Title")] = {
            fontSize: 16,
            fontWeight: 700,
            marginBottom: 8,
            color: '#cfd2d6',
        },
        _a["".concat(prefix, "Body")] = {
            fontSize: 13,
            lineHeight: 1.5,
            color: '#cfd2d6',
            marginBottom: 12,
        },
        _a["".concat(prefix, "Button")] = {
            width: '100%',
            border: 'none',
            borderRadius: 8,
            padding: '10px 12px',
            background: '#fd7200',
            color: '#000',
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
        },
        _a);
};
